import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import TemperatureConverter from '../components/tools/TemperatureConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Celsius to Kelvin Calculator | Temperature Unit Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert temperature instantly between Celsius, Kelvin, and Fahrenheit. Free online temperature calculator for coolant, exhaust, and ambient temperature conversions, with formulas and adjustable precision.';

const TemperatureConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="temperature-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="Celsius ↔ Kelvin Calculator"
        description="Convert temperature between Celsius, Kelvin, and Fahrenheit. Enter a value in any unit and the rest update in real time, with absolute-zero limits enforced."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="temperature-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <TemperatureConverter />
          <ToolGuideCta guidePath="/tools/temperature-calculator/guide" toolName="Celsius ↔ Kelvin Calculator" />
        </div>
      </section>
    </div>
  );
};

export default TemperatureConverterPage;
